export default __webpack_public_path__ + "static/media/highlight.eb0ea168.svg";